module.exports = {
    RECEIVE_HYDROMETRIC_STATION_FLOW: 'RECEIVE_HYDROMETRIC_STATION_FLOW',
    RECEIVE_HYDROMETRIC_STATION_PICTURES: 'RECEIVE_HYDROMETRIC_STATION_PICTURES',
    RECEIVE_HYDROMETRIC_STATION_FILES: 'RECEIVE_HYDROMETRIC_STATION_FILES',
    RESET_HYDROMETER_STATION: 'RESET_HYDROMETER_STATION',
    RECEIVE_HYDROMETRIC_ADDITIONAL_MEASURES: 'RECEIVE_HYDROMETRIC_ADDITIONAL_MEASURES',
    RECEIVE_HYDROMETER_CHART_OPTIONS: 'RECEIVE_HYDROMETER_CHART_OPTIONS',
    UPDATE_HYDROMETER_CHART_OPTIONS: 'UPDATE_HYDROMETER_CHART_OPTIONS',
}